<div class="navbar">
  <div class="d-f items-center">
    <a routerLink="/tabs/home">
      <img src="assets/icons/logo-full.svg">
    </a>
    @if (isLoggedIn()) {
      <div class="address" (click)="editAddress()">
        <ion-icon name="location" />
        {{ address() }}
        <ion-icon name="chevron-forward" />
      </div>
    }
  </div>
  <div>
    @if (isLoggedIn()) {
      <div class="cart" (click)="showCart()">
        <ion-icon name="cart" />
        @if (combinedItemCount() > 0) {
          <div class="count">{{ combinedItemCount() }}</div>
        }
      </div>
    } @else {
      <div class="buttons">
        <app-button (clicked)="login()" label="Login" [outlined]="true" />
        <app-button (clicked)="login()" label="Sign up" />
      </div>
    }
  </div>
</div>